import { ComponentRoute } from '@/classes'

const SalesAnalysisRoutes = {
  SalesAnalysisListView: new ComponentRoute('/salesanalysis', 'SalesAnalysisListView')
}

export default SalesAnalysisRoutes
